/* eslint-disable max-len */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import TheLayout from '../../layout/TheLayout';
import FirstView from '../../asset/firstview.png';
import NavSidebar from '../Util/NavSidebar/NavSidebar';
import AboutImg from '../../asset/About/about.png';
import Terraforesta from '../../asset/About/terraforesta.png';
import Terracoat from '../../asset/About/terracoat.png';
import TerraforestaSp from '../../asset/About/terraforestasp.png';
import TerracoatSp from '../../asset/About/terracoatsp.png';

import './about.css';

const keywords = ['TERRA', 'about', 'TERRAについて'];

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>TERRAについて｜株式会社TERRA</title>
      </Helmet>
      <div className="about">
        <div
          className="first_view d-flex align-items-center justify-content-center"
          style={{
            backgroundImage: `url(${FirstView})`,
            backgroundSize: '100% 100%',
            height: '15vh',
            fontSize: '2rem',
            letterSpacing: '1rem',
            color: 'white',
          }}
        >
          TERRAについて
        </div>
        <div className="d-none d-lg-block bg-white">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb" style={{ color: 'rgb(181,189,185)' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>TERRAについて</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="content container">
          <div className="row">
            <div className="col-3 d-none d-lg-block p-0" style={{ background: 'white' }}>
              <NavSidebar />
            </div>
            <div className="col-12 col-lg-9">
              <div className="p-2" style={{ color: 'rgb(44,81,115)' }}>
                <br />
                <br />
                <div className="text-center" style={{ lineHeight: '2' }}>
                  <p className="about-text-title" style={{ fontSize: '2rem', letterSpacing: '0.5rem' }}>
                    私たちは、
                    <br />
                    安全・安心な空間の創造を通して
                    <br />
                    社会貢献をしていく会社です。
                    <br />
                  </p>
                  <br />
                  <p className="about-text-desc" style={{ letterSpacing: '0.3rem', padding: '0 15%' }}>
                    約10年前より「光触媒」を用いた製品によって除菌・抗ウィルス・消臭の分野でビジネスを展開し、近年では感染症対策として様々な需要の増加に伴い、強力な抗菌・抗ウィルス作用を持つ天然由来の「フィトンチッド」含有製品である「TERRA FORESTA ミスト」および新型コロナウィルス不活化のエビデンスも取得済みで、最先端の液剤を使用した光触媒コーティング「TERRA COAT」の販売・施工を主力としたビジネスを展開している企業です。
                    <br />
                    <br />
                    新型コロナウィルスをこの世から完全に消し去ることは難しく、また次々に変異種も出現していることからも、感染症対策は一過性のものではなく、今後も継続的な対策が必要であることは間違いありません。
                    <br />
                    <br />
                    株式会社TERRAは継続的な感染症対策において、自社製品の普及による安全・安心な空間の創造を通して社会貢献することを目標としております。
                  </p>
                </div>
                <br />
                <img className="row d-none d-lg-block mb-5" src={AboutImg} style={{ width: '100%' }} alt="TERRA About" />
                <br />
                <div className="row d-none d-lg-flex mb-5">
                  <div className="col-lg-6">
                    <img src={Terraforesta} style={{ width: '100%' }} alt="TERRA FORESTA" />
                  </div>
                  <div className="col-lg-6">
                    <img src={Terracoat} style={{ width: '100%' }} alt="TERRA COAT" />
                  </div>
                </div>
                <div className="row d-block d-lg-none mb-5">
                  <div className="col-12">
                    <img src={TerraforestaSp} style={{ width: '100%' }} alt="TERRA FORESTA" />
                  </div>
                  <br />
                  <br />
                  <div className="col-12">
                    <img src={TerracoatSp} style={{ width: '100%' }} alt="TERRA COAT" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TheLayout>
  );
};
export default About;
